<template>
  <div class="tuk-spin" :class="{ picante: isPicante() }" :style="{ width: size + 'px', height: size + 'px' }">
    <div class="tuk-spin-ring" />
    <div class="tuk-spin-logo" />
  </div>
</template>

<script>
// Same look as the splash screen: round logo with a spinning ring. Also restyles the
// vue-loading-overlay spinner used by loadingDots() (see the unscoped style below).
export default {
  name: "TukSpinner",
  props: { size: { type: Number, default: 96 } },
};
</script>

<style>
.tuk-spin,
.vld-overlay .vld-icon {
  position: relative;
  width: 84px;
  height: 84px;
  /* only show after a short delay so quick page changes don't flash a spinner */
  animation: tuk-spin-in 0.2s ease 0.15s both;
}

.vld-overlay .vld-icon svg {
  display: none;
}

.tuk-spin-ring,
.vld-overlay .vld-icon::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 50%;
  border: 4px solid rgba(128, 128, 128, 0.25);
  border-top-color: #ffc800;
  border-right-color: #ffc800;
  animation: tuk-spin-rotate 1.15s cubic-bezier(0.55, 0.2, 0.45, 0.8) infinite;
}

.tuk-spin-logo,
.vld-overlay .vld-icon::after {
  content: "";
  position: absolute;
  top: 12%;
  right: 12%;
  bottom: 12%;
  left: 12%;
  border-radius: 50%;
  background: url("/img/icons/round-512x512.png") center / cover no-repeat;
  box-shadow: 0 6px 16px rgba(150, 100, 0, 0.35);
  animation: tuk-spin-float 2.4s ease-in-out infinite;
}

.tuk-spin.picante .tuk-spin-logo {
  background-image: url("/img/icons/picante_loading_grey.png");
}

/* dark theme: the blue palette of the splash screen (blue ring and glow, yellow logo) */
html[data-theme="dark"] .tuk-spin-ring,
html[data-theme="dark"] .vld-overlay .vld-icon::before {
  border-color: rgba(255, 255, 255, 0.14);
  border-top-color: var(--crypto-secondary, #2693da);
  border-right-color: var(--crypto-secondary, #2693da);
}

html[data-theme="dark"] .tuk-spin-logo,
html[data-theme="dark"] .vld-overlay .vld-icon::after {
  box-shadow: 0 0 22px rgba(38, 147, 218, 0.55);
}

/* the dimmed layer behind loadingDots() */
html[data-theme="dark"] .vld-overlay .vld-background {
  background: #0d0b11 !important;
  opacity: 0.7 !important;
}

@keyframes tuk-spin-rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes tuk-spin-float {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
}

@keyframes tuk-spin-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .tuk-spin-logo,
  .vld-overlay .vld-icon::after {
    animation: none;
  }
}
</style>
